
import React, { useState, useEffect }  from "react";
import { connect } from "react-redux";
import moment from 'moment';


import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  updatecountry,
} from '../api/country.api';



const LoftycountryUpdateModal = ({open, handleClose, successAction, token, doc}) => {
  
  
  useEffect(() => {
    const handleDataLoftyApps = async () => {
      try {


      } catch (error) {
        // error
      }
    }
    handleDataLoftyApps();
  }, []);
  return (
    <Dialog fullWidth open={open} onClose={handleClose}>
      <DialogTitle>
        Actualizar country
      </DialogTitle>
      <DialogContent>
        <form
          onSubmit={async e => {
            e.preventDefault();
            try {
              await updatecountry({
                token: token,
                _id: doc._id,
                name: e.target.name.value,
							code: e.target.code.value,

              });
              if (successAction) {
                successAction();
              }
              alert('Se agrego exitosamente el dato');
            } catch (error) {
              if (error.info) {
                alert(error.info);
              } else {
                alert('Lo sentimos no se logro agregar el dato');
              }
            }
          }}
        >
  				<div className="my-3">
					<TextField type="text" name="name" label="Nombre" variant="outlined" defaultValue={doc?.name} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="code" label="Codigo de telefono" variant="outlined" defaultValue={doc?.code} fullWidth />
				</div>

          <div className="my-3 text-center">
            <Button type="submit" variant="outlined" color="primary">
              Actualizar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = state => state.auth;

export default connect(mapStateToProps)(LoftycountryUpdateModal);
